import React from "react";
import Prod1 from "../../img/prod-1.jpg";
import Prod2 from "../../img/prod-2.jpg";
import Prod3 from "../../img/prod-3.jpg";
import Prod4 from "../../img/prod-4.jpg";

function Hero() {
  return (
    <section className="text-white bg-hero-extend h-[auto] xl:h-[840px] flex flex-col justify-center items-center space-y-[64px] py-4 p-9">
      <h3 className="text-2xl font-semibold">OUR PRODUCTS & SERVICES</h3>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4 md:w-[80%]">
        <div className="card">
          <img alt="" src={Prod1} className="w-full" />
          <h4 className="text-xl font-semibold text-[#244565] text-center">
            Mortgage Financing
          </h4>
          <div className="text-slate-700 text-sm flex flex-col space-y-2 text-center">
            <p>
              When you're looking for financing options, we're here to help.
            </p>
            <p>
              We offer a number of different mortgage products, including
              residential property, commercial property, industrial property and
              land financing. We understand that every borrower has different
              needs and we work with you to develop a personalized solution that
              meets your individual requirements.
            </p>
            <p>
              Whether you're buying a property or refinancing, we can help you
              find the right mortgage. We understand the challenges involved in
              getting a new mortgage, so our experienced team will work closely
              with you every step of the way.
            </p>
          </div>
        </div>
        <div className="card">
          <img alt="" src={Prod2} className="w-full" />
          <h4 className="text-xl font-semibold text-[#244565] text-center">
            Mortgage Insurance
          </h4>
          <div className="text-slate-700 text-sm flex flex-col space-y-2 text-center">
            <p>
              You're a homeowner, and you want to make sure that your family is
              taken care of. If something were to happen to you, would your
              family have enough money to keep their home?
            </p>
            <p>
              Mortgages insurance can help you with this. It protects your
              family by paying off the balance of your mortgage in case anything
              happens to you. It also covers any potential liabilities that may
              arise from owning a home.
            </p>
            <p>
              The peace of mind that comes with knowing your family is covered
              is priceless, which is why we recommend mortgages insurance for
              all homeowners.
            </p>
          </div>
        </div>
        <div className="card">
          <img alt="" src={Prod3} className="w-full" />
          <h4 className="text-xl font-semibold text-[#244565] text-center">
            Debts Restructuring
          </h4>
          <div className="text-slate-700 text-sm flex flex-col space-y-2 text-center">
            <p>
              Debt restructuring is a procedure to lower debts, improve
              financial flexibility and increase the individual or company’s
              ability to borrow even more in future. It can be applied to both
              current and capital debts, in order to improve liquidity and
              reduce interest costs.
            </p>
          </div>
        </div>
        <div className="card">
          <img alt="" src={Prod4} className="w-full" />
          <h4 className="text-xl font-semibold text-[#244565] text-center">
            Legacy Planning
          </h4>
          <div className="text-slate-700 text-sm flex flex-col space-y-2 text-center">
            <p>
              For some, the idea of legacy planning conjures up images of
              long-lost ancestors and dusty tomes. For us, it's about you and
              your family's future.
            </p>
            <p>
              If you've ever wondered how to make sure that your family will be
              taken care of after you're gone, or if you have an idea for a
              business but aren't sure how to get it off the ground, that's
              where we come in. We offer services that help you plan for all
              parts of your life—from passing down assets and businesses to
              ensuring peace of mind for loved ones.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
